import { CSSProperties } from 'react';

export interface ComboboxOption {
    value: string;
    label: string;
    disabled?: boolean;
    meta?: Record<string, unknown>;
}

interface ComboboxBase {
    name: string;
    label?: string;
    placeholder?: string;
    options: ComboboxOption[];
    loading?: boolean;
    disabled?: boolean;
    required?: boolean;
    error?: boolean;
    errorMessage?: string;
    /** Controlled search text. When omitted the component owns it internally. */
    query?: string;
    /** Raw un-debounced search callback. Debounce is the caller's responsibility. */
    onSearch?: (query: string) => void;
    onScrollEnd?: () => void;
    onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
    onClick?: () => void;
    onFocus?: () => void;
    /** Called when user presses Enter with a query that matches no existing option. */
    onUnknownOption?: (query: string) => void;
    renderOption?: (option: ComboboxOption, style: CSSProperties, selected: boolean) => React.ReactNode;
    minVisible?: number;
    pillCount?: number;
    containerClasses?: string;
    inputClassName?: string;
    optionDropdownClasses?: string;
    position?: 'top' | 'bottom';
    'data-test-id'?: string;
}

export interface SingleComboboxProps extends ComboboxBase {
    multiple?: false;
    /** The currently selected id/value */
    value: string | null;
    /** The resolved option for `value`. Passing this kills all value→label sync effects. */
    selectedOption: ComboboxOption | null;
    onChange: (value: string | null, option: ComboboxOption | null) => void;
}

export interface MultipleComboboxProps extends ComboboxBase {
    multiple: true;
    value: string[];
    /** The resolved options for each selected value. Caller-owned. */
    selectedOptions: ComboboxOption[];
    onChange: (values: string[], options: ComboboxOption[]) => void;
}

export type ComboboxProps = SingleComboboxProps | MultipleComboboxProps;
